import axios from "axios";
import helper from "./helper";
const http = axios.create();
http.defaults.baseURL = process.env.REACT_APP_API_URL;
if (localStorage.getItem("db")) {
  const storage = JSON.parse(helper.decrypt(localStorage.getItem("db")));
  const { token } = storage;
  http.defaults.headers.common.Authorization = `Bearer ${token?.token}`;
}
http.defaults.headers.post["Content-Type"] = "application/json";
http.defaults.headers.post["Accept"] = "application/json";

http.interceptors.request.use(
  (config) => {
    if (config.data && process.env.REACT_APP_ENABLE_ENCRYPTION === "true") {
      if (!(config.data instanceof FormData)) {
        config.data = {
          payload: helper.encrypt(JSON.stringify(config.data)),
        };
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.data.response &&
      process.env.REACT_APP_ENABLE_ENCRYPTION === "true"
    ) {
      try {
        const decryptedStr = helper.decrypt(response.data.response);
        response.data = JSON.parse(decryptedStr);
      } catch (e) {
        console.error("Failed to decrypt API response", e);
      }
    }
    return response;
  },
  (error) => {
    if (error.response !== undefined) {
      if (
        error.response.data &&
        error.response.data.response &&
        process.env.REACT_APP_ENABLE_ENCRYPTION === "true"
      ) {
        try {
          const decryptedStr = helper.decrypt(error.response.data.response);
          error.response.data = JSON.parse(decryptedStr);
        } catch (e) {
          console.error("Failed to decrypt API response", e);
        }
      }
      if (error.response.status === 401) {
        localStorage.removeItem("db");
        delete http.defaults.headers.common.Authorization;
        window.location.reload(true);
      }
    }
    return Promise.reject(error);
  },
);

export default http;
